export const NORWEGIAN_DATE_FORMAT = 'DD.MM.YYYY';
export const UNIVERSAL_DATE_FORMAT = 'YYYY-MM-DD';